<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-checkout"
      size="lg"
      scrollable
      centered
      @hide="hideModal"
      @close="hideModal"
    >
      <template #modal-title>
        <i class="icon-note"></i> REGISTRAR CHECK-OUT
      </template>

      <div class="form-group row">
        <div class="col-md-12 mb-2">
          <div class="row">
            <div class="col-md-6 mt-2">
              <NxSelectTipoVisita
                @update:value="handleSelectUpdate('tipoVisitasId', $event)"
              />
            </div>
            <div class="col-md-6 mt-2">
              <NxSelectStatusVisita
                @update:value="handleSelectUpdate('statusVisitas', $event)"
              />
            </div>
          </div>
        </div>

        <div class="col-md-12 mb-2">
          <div class="row">
            <div class="col-md-6 mt-2">
              <NxSelectTipoTransporte
                @update:value="handleSelectUpdate('tipoTransporteId', $event)"
              />
            </div>
            <div
              v-if="hasHodometroVisitas()"
              class="col-md-6 mt-2"
            >
              <label for="txtName">
                <small class="text-danger">*</small> Hodometro Atual:
              </label>
              <div class="input-group">
                <span class="input-group-addon">
                  <i class="fas fa-road"> </i
                ></span>
                <b-form-input
                  type="number"
                  min="0"
                  :placeholder="'Digite o Km Inicial'"
                  v-model="data.hodometroAtual"
                  :required="true"
                ></b-form-input>
              </div>
            </div>
          </div>
        </div>

        <hr class="w-100" />

        <div class="col-md-12">
          <div
            v-for="(item, index) in formData"
            :key="index"
            class="add-products-container__layout pl-3 py-2 mb-2"
          >
            <div class="form-group row">
              <div class="col-12 row" style="align-items: center">
                <div class="col-12 col-lg-8">
                  <NxSelectProduto
                    :value="item.produto"
                    :multiple="false"
                    @update:value="
                      handleArrayIndexUpdate(index, 'produto', $event, 'select')
                    "
                  />
                </div>
                <div class="col-8 col-lg-3">
                  <NxInputMoney
                    :value="item.valorProduto"
                    labelText="Valor do produto:"
                    @update:value="
                      handleArrayIndexUpdate(
                        index,
                        'valorProduto',
                        $event,
                        'input',
                        false
                      )
                    "
                  />
                </div>
                <div
                  class="col-1 pt-4 pointer"
                  style="margin: 0 auto"
                  @click.prevent="removeProductItemInArray(index)"
                >
                  <i
                    class="fas fa-times-circle fa-lg"
                    style="color: #ff0000"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button
              type="button"
              class="btn rounded-4 btn-third"
              @click="addProductItemInArray"
            >
              <i class="fas fa-plus"></i> Produto
            </button>
          </div>
        </div>

        <hr class="w-100" />

        <div class="col-md-12">
          <NxInputObservacao
            placeholder="Digite como foi a visita..."
            @update:value="handleInputUpdate('comentario', $event, false)"
          />
        </div>

        <hr class="w-100" />

        <div class="col-md-12">
          <div
            class="d-flex"
            style="
              justify-content: start;
              align-items: start;
              gap: 1rem;
              cursor: pointer;
            "
            v-show="cards.length > 0"
            @click="toggleUpdateCard"
          >
            <ToogleSwitch :value="hasUpdatingCard" />
            <h6 style="line-height: 100%">Vincular à oportunidade existente</h6>
          </div>

          <section
            v-if="hasUpdatingCard"
            class="row"
          >
            <div
              class="input-group"
              style="background: none"
            >
              <div class="col-md-6 mt-2">
                <SelectEvento
                  @onSelect="saveEvento"
                  :selectedOption="data.eventoId"
                />
              </div>
              <div class="col-md-6 mt-2">
                <NxSelectMotivoPerda
                  @update:value="handleSelectUpdate('motivoId', $event)"
                  v-if="data.statusVisitas == 0"
                />
                <NxSelectMotivoFinalizado
                  @update:value="handleSelectUpdate('motivoId', $event)"
                  v-if="data.statusVisitas == 3"
                />
              </div>

              <div class="p-3">
                <Tables
                  class=""
                  ref="tableGrid"
                  :columns="[
                    ' ',
                    'Protocolo',
                    'Quadro',
                    'Coluna',
                    'Responsável',
                    'Data Abertura'
                  ]"
                  v-on:Load="onLoad"
                >
                  <tr
                    v-for="(obj, index) in this.objList"
                    v-bind:key="index + '-' + obj.id"
                  >
                    <td class="text-center col-1">
                      <b-form-checkbox
                        :id="`checkbox-${obj.id}`"
                        v-model="cardsIdsToUpdate"
                        :name="`checkbox-${obj.id}`"
                        :value="obj.id"
                      ></b-form-checkbox>
                    </td>
                    <TableColumn
                      :IsText="true"
                      v-on:Edit="openCardModal(obj.id)"
                      :status="1"
                      :value="obj.protocolo ? obj.protocolo : '-'"
                    />
                    <TableColumn
                      :IsText="true"
                      v-on:Edit="openCardModal(obj.id)"
                      :status="1"
                      :value="
                        obj.boardColumn.board.nome
                          ? obj.boardColumn.board.nome
                          : '-'
                      "
                    />
                    <TableColumn
                      :IsText="true"
                      v-on:Edit="openCardModal(obj.id)"
                      :status="1"
                      :value="obj.boardColumn.nome ? obj.boardColumn.nome : '-'"
                    />
                    <TableColumn
                      :IsText="true"
                      v-on:Edit="openCardModal(obj.id)"
                      :status="1"
                      :value="
                        obj.responsaveis.length > 0 &&
                        obj.responsaveis[0].usuario
                          ? obj.responsaveis[0].usuario.nomePessoa
                          : '-'
                      "
                    />
                    <TableColumn
                      :IsText="true"
                      v-on:Edit="openCardModal(obj.id)"
                      :status="1"
                      :value="
                        obj.dataCriacao
                          ? formatDate(obj.dataCriacao, true)
                          : '-'
                      "
                    />
                  </tr>
                </Tables>
              </div>
            </div>
          </section>
        </div>
        <div class="col-md-12">
          <div
            class="d-flex"
            style="
              justify-content: start;
              align-items: start;
              gap: 1rem;
              cursor: pointer;
            "
            @click="toggleCreateCard"
          >
            <ToogleSwitch :value="hasCreationCard" />
            <h6 style="line-height: 100%">Criar Oportunidade</h6>
          </div>

          <section
            v-if="hasCreationCard"
            class="row"
          >
            <div
              class="input-group"
              style="background: none"
            >
              <div class="col-md-6 mt-2">
                <SelectEvento
                  @onSelect="saveEvento"
                  :selectedOption="data.eventoId"
                />
              </div>
              <div class="col-md-6 mt-2">
                <SelectBoard
                  :onlyActive="true"
                  :selectedOption="data.boardId"
                  @onSelect="loadColumns"
                />
              </div>
              <div class="col-md-6 mt-2">
                <SelectBoardColumn
                  v-if="data.boardId"
                  :boardId="data.boardId"
                  :key="data.boardId"
                  :selectedOption="data.boardColumnId"
                  @onSelect="saveBoardAndColumn"
                />
              </div>
              <div class="col-md-6 pt-2">
                <SelectOrigem
                  v-if="data.boardColumnId"
                  :selectedOption="data.origemId"
                  @onSelect="saveOrigin"
                />
              </div>
            </div>
          </section>
        </div>
      </div>

      <template #modal-footer>
        <DefaultButton
          btnVariant="btn-third justify-content-center"
          :onClick="onSave"
          icon="fas fa-check-circle"
          text="Salvar"
        />
      </template>
    </b-modal>
    <ModalCard
      ref="ModalCard"
      v-if="selectedCardOpen"
      :boardColumns="[]"
      @hideModal="closeCardModal"
      :key="selectedCardOpen"
      :cardId="selectedCardOpen"
    />
  </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ParametroAberturaCardsVisitaRepository from '@/shared/http/repositories/configurations/parametroAberturaCardsVisita.js'
import CardRepository from '@/shared/http/repositories/crm/card.js'
import DeslocamentoRepository from '@/shared/http/repositories/deslocamento/deslocamento.js'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'

import {
  NxInputMoney,
  NxInputObservacao
} from '@/components/nexum/components/custom-inputs/index.js'
import {
  NxSelectMotivoPerda,
  NxSelectMotivoFinalizado,
  NxSelectProduto,
  NxSelectStatusVisita,
  NxSelectTipoTransporte,
  NxSelectTipoVisita
} from '@/components/nexum/components/custom-selects/index.js'
import Tools from '@/components/tools/Tools.js'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectEvento from '@/components/forms/selects/SelectEvento.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'

export default {
  name: 'CheckOutModal',
  mixins: [ActionsForm],
  data () {
    return {
      data: {
        id: null,
        deslocamentoId: null,
        tipoVisitasId: null,
        tipoTransporteId: null,
        statusVisitas: null,
        hasProduct: false,
        listaProdutos: null,
        comentario: null,
        hasCreationCard: false,
        hasUpdatingCard: false,
        eventoId: null,
        boardId: null,
        boardColumnId: null,
        origemId: null,
        motivoId: null,
        cardsIdsToUpdate: [],
        hodometroAtual: null
      },
      visitaId: null,
      pessoa: null,
      cards: null,
      selectedCardOpen: null,
      cardsResponse: null,
      hasUpdatingCard: false,
      hasCreationCard: false,
      cardsIdsToUpdate: [],
      formData: []
    }
  },
  components: {
    DefaultButton,
    ToogleSwitch,
    ModalCard,

    NxSelectTipoVisita,
    NxSelectStatusVisita,
    NxSelectProduto,
    NxSelectTipoTransporte,
    NxInputMoney,
    NxInputObservacao,
    NxSelectMotivoPerda,
    NxSelectMotivoFinalizado,

    SelectBoard,
    SelectBoardColumn,
    SelectOrigem,
    SelectEvento
  },
  async mounted () {
    Tools.MinimizedSidebar()
    const resp = await DeslocamentoRepository.GetActive()
    if (
      resp.data === '' ||
      resp.data.visitas === null ||
      resp.data.visitas.length === 0
    ) {
      this.onBack()
      return
    }
    const visita = resp.data.visitas.find((v) => v.dataCheckOut === null)
    if (visita === null) {
      this.onBack()
      return
    }
    this.visitaId = visita.id
    this.pessoa = visita.pessoa

    this.loadCards()
  },
  methods: {
    async showModal () {
      loading.push()
      await this.getDeslocamento()
      this.$refs['modal-checkout'].show()
    },
    hideModal () {
      this.$refs['modal-checkout'].hide()
    },
    async getDeslocamento () {
      try {
        const response = await DeslocamentoRepository.GetActive()

        if (response.data === '') return

        const visita = response.data.visitas.find(
          v => v.dataCheckOut === null
        )

        if (visita === null) return

        this.data.id = visita.id
        this.data.deslocamentoId = response.data.id
      } catch (e) {
        console.error(e)
      } finally {
        loading.close()
      }
    },
    async getKmRodadoHodometro (hodometroAtual) {
      const { data } = await DeslocamentoRepository.GetCoordinates(
        this.data.deslocamentoId
      )

      if (data.hodometro == null) return null

      const hodometroInicial = data.hodometro
      const hodometroFinal = hodometroAtual

      return hodometroFinal - hodometroInicial
    },
    async getParametrosOpenCard () {
      try {
        loading.push()
        const resp = await ParametroAberturaCardsVisitaRepository.Get()

        if (!resp || !resp.data) return

        this.data.eventoId = resp.data.eventoId
        this.data.boardId = resp.data.boardId
        this.data.boardColumnId = resp.data.boardColumnId
        this.data.origemId = resp.data.origemLeadId
      } catch (error) {
        this.onExceptionWithErrorMessage(error)
      } finally {
        loading.close()
      }
    },
    async onUpdate () {
      try {
        if (this.hasCreationCard && !this.checkFieldsCreateCard()) return
        if (this.hasUpdatingCard && !this.checkFieldsUpdateCard()) return
        if (this.checkRequiredFields()) return

        loading.push()

        this.data.hasCreationCard = this.hasCreationCard
        this.data.hasUpdatingCard = this.hasUpdatingCard
        this.setProductListOnData()
        this.data.kmRodadoPorHodometro = await this.getKmRodadoHodometro(
          this.data.hodometroAtual
        )

        await DeslocamentoRepository.CheckOut(this.data)

        toast.success(this.$lang.Common.Alerts.Success)
        this.hideModal()
        location.reload()
      } catch (error) {
        let errorMessage = error.response.data.errors[0].message.toUpperCase()
        if (error.response.data.errors && errorMessage.search('NÃO') !== -1) {
          toast.error(
            error.response.data.errors[0].message,
            'Erro ao salvar checkout'
          )
        } else {
          toast.error(this.$lang.Common.Alerts.Error)
        }
      } finally {
        loading.pop()
      }
    },
    async loadCards () {
      CardRepository.SearchAllByDocument(
        this.pessoa.document,
        '&situacao=ATIVO&',
        100,
        0
      ).then((response) => {
        this.cards = response.data.content
        this.onResultGrid(response)
      })
    },
    async toggleCreateCard () {
      this.hasCreationCard = !this.hasCreationCard
      if (this.hasCreationCard && this.hasUpdatingCard) {
        this.hasUpdatingCard = !this.hasUpdatingCard
      }
      if (this.hasCreationCard) {
        await this.getParametrosOpenCard()
      }
    },
    async toggleUpdateCard () {
      this.hasUpdatingCard = !this.hasUpdatingCard
      if (this.hasCreationCard && this.hasUpdatingCard) {
        this.hasCreationCard = !this.hasCreationCard
      }

      if (this.hasUpdatingCard) this.loadCards()
    },
    checkRequiredFields () {
      const valuesToCheck = [null, undefined]
      if (
        valuesToCheck.includes(this.data.statusVisitas) ||
        valuesToCheck.includes(this.data.tipoVisitasId) ||
        valuesToCheck.includes(this.data.tipoTransporteId) ||
        (this.hasHodometroVisitas() &&
          valuesToCheck.includes(this.data.hodometroAtual))
      ) {
        toast.warning(this.$lang.Common.Alerts.RequiredField)
        return true
      }
      return false
    },
    checkFieldsUpdateCard () {
      if (this.cardsIdsToUpdate) {
        this.data.cardsIdsToUpdate = this.cardsIdsToUpdate
        return true
      }

      toast.warning(
        'Nenhuma oportunidade foi selecionada',
        'Vincular oportunidade'
      )

      return false
    },
    checkFieldsCreateCard () {
      if (
        this.data.boardId &&
          this.data.boardColumnId &&
          this.data.origemId
      ) {
        return true
      }

      toast.warning(
        'Todos os campos devem estar preenchidos',
        'Criar oportunidade'
      )

      return false
    },
    saveEvento (eventoId) {
      this.data.eventoId = eventoId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.data.boardId = boardAndColumn[0]
      this.data.boardColumnId = boardAndColumn[1]
    },
    loadColumns (boardId) {
      this.data.boardId = boardId
    },
    saveOrigin (origin) {
      this.data.origemId = origin
    },
    openCardModal (cardId) {
      this.selectedCardOpen = cardId
    },
    closeCardModal () {
      this.selectedCardOpen = null
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
          typeof selectedValue === 'number'
      ) {
        this.data[fieldName] = selectedValue
        return
      }

      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }

      // If to clear single select and update both types
      this.data[fieldName] = selectedValue
        ? Array.isArray(selectedValue)
          ? selectedValue.map(v => v.value)
          : selectedValue.value
        : this.clearField(fieldName)
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      this.data[fieldName] = inputedValue
        ? clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
        : this.clearField(fieldName)
    },
    handleArrayIndexUpdate (
      index,
      fieldName,
      selectedValue,
      inputType,
      clean = true
    ) {
      // If field is on array index
      if (index < 0) return

      if (inputType === 'select') {
        // If input comes as a string or a number
        if (
          typeof selectedValue === 'string' ||
            typeof selectedValue === 'number'
        ) {
          this.formData[index][fieldName] = selectedValue
          return
        }
        // If to clear multiple select
        if (Array.isArray(selectedValue) && !selectedValue.length) {
          this.formData[index][fieldName] = null
          return
        }
        // If to clear single select and update both types
        this.formData[index][fieldName] = selectedValue || null
      } else {
        this.formData[index][fieldName] = selectedValue
          ? clean
            ? selectedValue.replace(/[^a-zA-Z0-9 ]/g, '')
            : selectedValue
          : null
      }
    },
    clearField (field) {
      this.data[field] = null
    },
    addProductItemInArray () {
      this.formData.push({
        produto: null,
        valorProduto: 0
      })
    },
    removeProductItemInArray (index) {
      this.formData.splice(index, 1)
    },
    setProductListOnData () {
      if (this.formData.length === 0) {
        this.data.hasProduct = false
        this.data.listaProdutos = null
        return
      }

      this.data.hasProduct = true

      this.data.listaProdutos = this.formData.map(item => ({
        produtoId: item.produto.value,
        valorProduto: item.valorProduto
      }))
    },
    formatDate (d, hasTime) {
      const date = new Date(d)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const seconds = date.getSeconds().toString().padStart(2, '0')

      return (
        `${day}/${month}/${year}` +
        (hasTime ? ` às ${hours}:${minutes}:${seconds}` : '')
      )
    }
  }
}
</script>

<style lang="scss">
  #produtcs-groups {
    .formulate-input {
      margin-bottom: 0px;

      .formulate-input-element {
        max-width: none;

        textarea {
          height: 7rem;
          border-radius: 0.3rem 0.3rem 0px 0px;
          resize: none;
        }
      }
    }
  }

  .add-products-container__layout {
    background-color: rgb(229, 229, 229);
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/visitas/deslocamento/register/modal/checkout.vue